class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form')
    this.atc = this.querySelector('[type="submit"]')
  }

  async handleSubmit(e) {
    e.preventDefault()

    this.atc.setAttribute('disabled', '')
    const formData = new FormData(form);

    await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      if (window.Rebuy && Rebuy.SmartCart && Rebuy.SmartCart.show) {
        Rebuy.SmartCart.show();
      }
    })
    .catch(error => {
      console.error('Add to cart failed', error);
    })
    this.atc.removeAttribute('disabled')
  }
}

customElements.define('product-card', ProductCard);


Array.from(document.querySelectorAll('.product-card-video-loop')).forEach(video => {
  if (window.innerWidth > 767) {
    video.addEventListener("mouseenter", function () {
      try {
        video.play()
      } catch (error) {

      }
    })
    video.addEventListener("mouseleave", function () {
      video.loop = false
    })
  } else {
    try {
      video.play()
    } catch (error) {

    }
  }
})

Array.from(document.querySelectorAll('.product-accordion .accordion-item')).forEach(item => {
    item.addEventListener('click', (e) => {
        const itemBody = item.querySelector('.accordion-item-body');
        if (e.target != itemBody) {
            item.classList.toggle("opened");    
        }
    })
})

window.handleQtybox = function(wrapper, e) {
  const input = wrapper.querySelector('input')
  const value = Number(input.value)

  if (e.target.classList.contains('qtyminus')) input.value = Math.max(value - 1, 1)
  else if (e.target.classList.contains('qtyplus')) input.value = value + 1
}
// Deployment read more / read less product description mobile version
  document.addEventListener('DOMContentLoaded',function(){
    const descBox = document.querySelector('.product_desc_box');
    if (!descBox) return;

    const toggleContent = (e) => {
        descBox.classList.toggle('is-collapsed');
        e.target.innerText = descBox.classList.contains('is-collapsed') ? 'Read More' : 'Read Less';
    };

    const handleReadMoreLogic = () => {
        const isMobile = window.innerWidth < 768;
        const existingBtn = document.querySelector('.read-more-toggle');

        isMobile ? 
            (!existingBtn && createButton()) : 
            (existingBtn && destroyButton(existingBtn));
    };

    const createButton = () => {
        descBox.classList.add('is-collapsed');
        const btn = document.createElement('button');
        btn.className = 'read-more-toggle';
        btn.setAttribute('type', 'button');
        btn.innerText = 'Read More';
        btn.addEventListener('click', toggleContent);
        descBox.parentNode.insertBefore(btn, descBox.nextSibling);
    };

    const destroyButton = (btn) => {
        descBox.classList.remove('is-collapsed');
        btn.remove();
    };

    handleReadMoreLogic();

    window.addEventListener('resize', () => handleReadMoreLogic());

    const observer = new MutationObserver(() => handleReadMoreLogic());
    observer.observe(document.body, { childList: true, subtree: true });
  })